import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Col } from 'react-flexbox-grid';
import moment from 'moment';
import { ListItem, Divider, FlatButton, FontIcon, MenuItem, SelectField, Subheader, Paper } from 'material-ui';
import { capitalize } from 'lodash';

import Loading from 'components/Loading';
import PanelMessage from 'components/panels/PanelMessage';
import { fetchUserPayslips, downloadFile, setPayYear, initPayYear } from 'actions/Files';
import styles from 'styles/base';

const Payslip = () => {
  const dispatch = useDispatch();

  const { FileReducer, languageReducer } = useSelector(state => state);
  const {
    payslipsLoaded, payslips, hasError, error, payYear, payYearOptions,
  } = FileReducer;
  const { language } = languageReducer;
  moment.locale(language);

  useEffect(() => {
    dispatch(initPayYear());
  }, []);

  if (!payslipsLoaded) {
    return <Loading />;
  }

  if (hasError) {
    return (
      <Col xs={12} sm={12} md={8} mdOffset={2} style={{ paddingTop: 0, paddingBottom: 16 }}>
        <PanelMessage
          type="error"
          iconName="error"
          message={error && error.Message ? error.Message : <FormattedMessage id="payslip.error" />}
        />
      </Col>
    );
  }

  const setYear = (year) => {
    dispatch(setPayYear(year));
    dispatch(fetchUserPayslips());
  };

  const download = id => dispatch(downloadFile(id));

  return (
    <Col xs={12} sm={12} md={8} mdOffset={2} style={{ paddingTop: 0, paddingBottom: 16 }}>
      <Subheader style={styles.subheader}><FormattedMessage id="payslip.title" /></Subheader>
      <SelectField
        disabled={payYearOptions.length === 0}
        floatingLabelText={<FormattedMessage id="payslip.select" />}
        value={payYear}
        onChange={(a, b, value) => setYear(value)}
      >
        {payYearOptions.map(y => <MenuItem key={y} value={y} primaryText={y} />)}
      </SelectField>
      {(payslipsLoaded && payslips.length < 1) && <PanelMessage message={<FormattedMessage id="payslip.empty" />} type="info" iconName="info" />}
      <Paper>
        {payslips.map(slip => (
          <div key={slip.PaySlipGuid}>
            <ListItem
              primaryText={capitalize(moment().month(slip.PayMonth).format('MMMM'))}
              disabled
              secondaryText={`${moment(slip.PayPeriodBegda).format('LL')} - ${moment(slip.PayPeriodEndda).format('LL')}`}
              rightIconButton={
                <FlatButton
                  style={{ top: 'auto', right: 16 }}
                  onClick={() => download(slip.PaySlipGuid)}
                  icon={<FontIcon className="material-icons">file_download</FontIcon>}
                  label={<FormattedMessage id="payslip.download" />}
                />}
            />
            <Divider />
          </div>
        ))}
      </Paper>
    </Col>
  );
};

export default Payslip;



// WEBPACK FOOTER //
// ./src/containers/Payslip.js